import { render, staticRenderFns } from "./ShopRenderer.vue?vue&type=template&id=11ad20dc&scoped=true"
import script from "./ShopRenderer.vue?vue&type=script&lang=js"
export * from "./ShopRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ad20dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ad20dc')) {
      api.createRecord('11ad20dc', component.options)
    } else {
      api.reload('11ad20dc', component.options)
    }
    module.hot.accept("./ShopRenderer.vue?vue&type=template&id=11ad20dc&scoped=true", function () {
      api.rerender('11ad20dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/gift/plugins/default-shop/ui/ShopRenderer.vue"
export default component.exports